import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "deleteFolderModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "renameModalLabel"
}, "Delete", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "alert alert-danger mb-0",
  role: "alert"
}, " Are you sure? You want to delete. ", -1)
const _hoisted_10 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.errorList.delete,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _hoisted_9
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("button", {
              type: "button",
              class: "btn default-btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteSelected && _ctx.deleteSelected(...args)))
            }, "Ok"),
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              "data-dismiss": "modal",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, " Close ")
          ])
        ])
      ])
    ])
  ]))
}